'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M16 112l416 0 0 64-288 0 0 256-128 0 0-320z', 'M160 48l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zM144 96l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 144 0 0 80-16 0 0-64-416 0 0 320 128 0 0 16-144 0 0-352 144 0zm64 144l0 256 352 0 0-256-352 0zm-16-16l384 0 0 288-384 0 0-288zm128 88l0 40c0 35.3 28.7 64 64 64s64-28.7 64-64l0-40 16 0 0 40c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-40 16 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;